import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function BarrierSystemsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = "Bariyer Sistemleri Kurulumu İstanbul | Otomatik Bariyer Plaka Tanıma";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel bariyer sistemleri kurulumu. Otomatik açılma, plaka tanıma entegrasyonu ve uzaktan kumanda ile araç giriş-çıkış kontrolü.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel bariyer sistemleri kurulumu. Otomatik açılma, plaka tanıma entegrasyonu ve uzaktan kumanda ile araç giriş-çıkış kontrolü.';
      document.head.appendChild(meta);
    }

    // Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'bariyer sistemi, otomatik bariyer, plaka tanıma sistemi, otopark bariyeri, fabrika bariyer kurulumu');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'bariyer sistemi, otomatik bariyer, plaka tanıma sistemi, otopark bariyeri, fabrika bariyer kurulumu';
      document.head.appendChild(meta);
    }

    // Open Graph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Bariyer Sistemleri Kurulumu İstanbul | Otomatik Bariyer Plaka Tanıma');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Bariyer Sistemleri Kurulumu İstanbul | Otomatik Bariyer Plaka Tanıma';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fabrika, sanayi tesisi ve otopark için dayanıklı bariyer sistemleri. Hızlı açılma, LED aydınlatma ve plaka tanıma entegrasyonu.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fabrika, sanayi tesisi ve otopark için dayanıklı bariyer sistemleri. Hızlı açılma, LED aydınlatma ve plaka tanıma entegrasyonu.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/guvenlik-sistemleri/bariyer-sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/guvenlik-sistemleri/bariyer-sistemleri';
      document.head.appendChild(meta);
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/guvenlik-sistemleri/bariyer-sistemleri');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/guvenlik-sistemleri/bariyer-sistemleri';
      document.head.appendChild(link);
    }

    // Cleanup function
    return () => {
      document.title = 'Fiber Optik Ustası';
    };
  }, []);

  const features = [
    { icon: 'ri-speed-line', title: 'Hızlı Açılma', description: '1-3 saniyede otomatik açılma' },
    { icon: 'ri-car-line', title: 'Plaka Tanıma', description: 'Otomatik plaka okuma sistemi' },
    { icon: 'ri-remote-control-line', title: 'Uzaktan Kumanda', description: 'RF kumanda ile kontrol' },
    { icon: 'ri-lightbulb-line', title: 'LED Aydınlatma', description: 'Kolda LED ışık sistemi' },
    { icon: 'ri-shield-check-line', title: 'Güvenlik Sensörleri', description: 'Çarpma önleme sistemi' },
    { icon: 'ri-battery-line', title: 'Yedek Güç', description: 'Elektrik kesintisinde çalışma' }
  ];

  const barrierTypes = [
    {
      title: 'Standart Bariyer Sistemleri',
      description: 'Fabrika girişleri, otopark ve sanayi tesisleri için 3-4 metre kol uzunluğunda standart bariyerler. Ekonomik ve güvenilir çözüm.',
      specs: ['3-4m kol uzunluğu', '1-3 sn açılma', 'Elektro-mekanik motor', 'Manuel açma']
    },
    {
      title: 'Yüksek Hızlı Bariyer Sistemleri',
      description: 'Yoğun trafik olan alanlarda kullanılan hızlı açılma kapanma özellikli bariyerler. 1 saniyede açılır, yüksek geçiş kapasitesi sağlar.',
      specs: ['1 sn açılma', 'Yüksek döngü ömrü', 'Frekans kontrol', 'Yumuşak hareket']
    },
    {
      title: 'Uzun Kollu Bariyer Sistemleri',
      description: 'Geniş geçiş alanları için 6 metreye kadar kol uzunluğunda bariyerler. Çift kol veya teleskopik kol seçenekleri mevcuttur.',
      specs: ['6m kol uzunluğu', 'Teleskopik kol', 'Güçlü motor', 'Rüzgar direnci']
    },
    {
      title: 'Otomatik Plaka Tanıma Entegreli Bariyerler',
      description: 'Plaka tanıma sistemi ile entegre çalışan akıllı bariyerler. Kayıtlı araçlar için otomatik açılma sağlar.',
      specs: ['LPR entegrasyonu', 'Otomatik açılma', 'Araç kayıt sistemi', 'Raporlama']
    }
  ];

  const faqs = [
    {
      question: 'Bariyer sistemleri nasıl çalışır?',
      answer: 'Bariyer sistemleri, elektro-mekanik veya hidrolik motor ile çalışan otomatik geçiş kontrol cihazlarıdır. Uzaktan kumanda, kart okuyucu, plaka tanıma sistemi veya buton ile tetiklendiğinde, motor devreye girer ve bariyer kolu yukarı kalkar. Araç geçtikten sonra otomatik olarak kapanır veya tekrar kumanda ile kapatılır. Güvenlik sensörleri sayesinde, kol altında araç veya insan varken kapanmaz.'
    },
    {
      question: 'Hangi bariyer türünü seçmeliyim?',
      answer: 'Bariyer seçimi, geçiş alanının genişliğine ve kullanım yoğunluğuna göre yapılır. 3-4 metre geçiş için standart bariyerler yeterlidir. Geniş geçişler için 6 metreye kadar uzun kollu bariyerler kullanılır. Yoğun trafik olan alanlarda yüksek hızlı bariyerler tercih edilir. Fabrika ve sanayi tesislerinde genellikle plaka tanıma sistemi entegreli bariyerler kullanılır. Profesyonel keşif sonrası en uygun bariyer önerilir.'
    },
    {
      question: 'Bariyer sistemi kurulumu ne kadar sürer?',
      answer: 'Tek bariyer kurulumu genellikle 4-6 saat sürer. Kurulum, zemin hazırlığı, bariyer montajı, elektrik bağlantısı, kontrol paneli kurulumu ve test işlemlerini içerir. Plaka tanıma sistemi entegrasyonu ekstra 2-3 saat gerektirir. Çift yönlü geçiş için iki bariyer kurulumu 1 gün sürer. Kurulum sonrası kullanıcı eğitimi verilir ve garanti belgesi düzenlenir.'
    },
    {
      question: 'Elektrik kesintisinde bariyer açılır mı?',
      answer: 'Evet, bariyer sistemleri yedek pil ile donatılabilir. Elektrik kesintisinde sistem 50-100 açma-kapama döngüsü yapabilir. Ayrıca, tüm bariyerlerde manuel açma mekanizması bulunur. Acil durumlarda özel anahtar ile bariyer kolu manuel olarak kaldırılabilir. Yangın alarm sistemi ile entegrasyon yapılarak, yangın durumunda otomatik açılma sağlanabilir.'
    },
    {
      question: 'Bariyer sistemleri bakım gerektirir mi?',
      answer: 'Evet, bariyer sistemleri düzenli bakım gerektirir. Yılda en az 2 kez periyodik bakım yapılmalıdır. Bakımda motor yağlaması, kol dengesi kontrolü, güvenlik sensörü testi, elektrik bağlantıları kontrolü ve yazılım güncellemesi yapılır. Düzenli bakım, bariyerin ömrünü uzatır ve arıza riskini azaltır. Bakım sözleşmelerimiz ile tüm bu işlemler profesyonelce gerçekleştirilir.'
    },
    {
      question: 'Hangi bölgelerde bariyer sistemleri kurulumu yapıyorsunuz?',
      answer: 'İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Ataşehir, Kadıköy, Ümraniye, Esenyurt, Başakşehir, Pendik, Kartal, Beylikdüzü, Tuzla, Gebze, Dilovası, Çayırova, Kocaeli, Sakarya, Yalova, Bursa, Tekirdağ ve Çorlu bölgelerinde bariyer sistemleri kurulumu hizmeti veriyoruz. Fabrika, sanayi tesisi, OSB, otopark ve kurumsal işletmelere profesyonel bariyer çözümleri sunuyoruz.'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/c24bd248660520b677a90de5e274aa45.jpg"
            alt="Bariyer Sistemleri"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/85 to-slate-950"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-slate-400 transition-colors cursor-pointer">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/guvenlik-sistemleri" className="hover:text-slate-400 transition-colors cursor-pointer">Güvenlik Sistemleri</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-slate-400">Bariyer Sistemleri</span>
          </nav>

          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-600/20 border border-slate-500/30 rounded-full mb-6">
              <i className="ri-roadster-line text-slate-400 text-lg"></i>
              <span className="text-slate-300 text-sm font-medium">Otomatik Bariyer Sistemleri</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Bariyer Sistemleri Kurulumu
            </h1>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde fabrika, sanayi tesisi, otopark ve kurumsal işletmeler için profesyonel bariyer sistemleri kurulumu. Otomatik açılma, plaka tanıma entegrasyonu ve uzaktan kumanda ile araç giriş-çıkış kontrolü.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-slate-700 to-slate-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-slate-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp Destek
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <article className="prose prose-invert prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-white mb-6">Bariyer Sistemleri Nedir?</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Bariyer sistemleri, araç giriş-çıkışlarını kontrol eden otomatik geçiş kontrol cihazlarıdır. Fabrika girişleri, otopark, sanayi tesisi ve kurumsal işletme girişlerinde kullanılarak, sadece yetkili araçların girmesine izin verir. Elektro-mekanik veya hidrolik motor ile çalışan bariyer kolu, uzaktan kumanda, kart okuyucu veya plaka tanıma sistemi ile tetiklendiğinde otomatik olarak açılır ve kapanır.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Modern bariyer sistemleri, LED aydınlatma, güvenlik sensörleri, yedek güç kaynağı ve akıllı kontrol sistemleri ile donatılmıştır. İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde profesyonel bariyer sistemleri kurulumu hizmeti veriyoruz. Standart, yüksek hızlı ve uzun kollu bariyer seçenekleri ile her ihtiyaca uygun çözümler sunuyoruz.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bariyer Sistemlerinin Özellikleri</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 not-prose">
                {features.map((feature, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-slate-500/50 transition-all duration-300">
                    <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-lg mb-4">
                      <i className={`${feature.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bariyer Türleri ve Özellikleri</h2>
              <div className="space-y-6 mb-8 not-prose">
                {barrierTypes.map((barrier, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-slate-500/50 transition-all duration-300">
                    <h3 className="text-2xl font-bold text-white mb-3">{barrier.title}</h3>
                    <p className="text-gray-300 leading-relaxed mb-4">{barrier.description}</p>
                    <div className="flex flex-wrap gap-3">
                      {barrier.specs.map((spec, idx) => (
                        <span key={idx} className="px-3 py-1 bg-slate-600/20 border border-slate-500/30 rounded-full text-slate-300 text-sm">
                          {spec}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bariyer Sistemi Kurulum Süreci</h2>
              <div className="space-y-6 mb-8 not-prose">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-full text-white font-bold">1</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Keşif ve Ölçüm</h3>
                    <p className="text-gray-300">Kurulum alanı incelenir, geçiş genişliği ölçülür. Zemin yapısı kontrol edilir, elektrik altyapısı değerlendirilir.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-full text-white font-bold">2</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Bariyer Seçimi</h3>
                    <p className="text-gray-300">Geçiş genişliğine ve kullanım yoğunluğuna göre uygun bariyer modeli seçilir. Plaka tanıma veya kart okuyucu entegrasyonu planlanır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-full text-white font-bold">3</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Zemin Hazırlığı</h3>
                    <p className="text-gray-300">Bariyer temeli için zemin kazısı yapılır, beton dökülerek sağlam temel oluşturulur. Elektrik kablo kanalları hazırlanır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-full text-white font-bold">4</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Montaj ve Bağlantı</h3>
                    <p className="text-gray-300">Bariyer gövdesi monte edilir, kol takılır ve dengelenir. Elektrik bağlantıları yapılır, kontrol paneli kurulur.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-slate-700 to-slate-600 rounded-full text-white font-bold">5</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Test ve Ayar</h3>
                    <p className="text-gray-300">Açılma-kapanma hızı ayarlanır, güvenlik sensörleri test edilir. Uzaktan kumanda eşleştirilir ve kullanıcı eğitimi verilir.</p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Plaka Tanıma Sistemi Entegrasyonu</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Bariyer sistemleri, plaka tanıma sistemi (LPR - License Plate Recognition) ile entegre çalışabilir. Kamera, yaklaşan aracın plakasını okur ve veritabanında kontrol eder. Kayıtlı araçlar için bariyer otomatik olarak açılır, kayıtsız araçlar için güvenlik personeline bildirim gönderilir. Bu sistem, fabrika ve sanayi tesislerinde personel araçları, ziyaretçi araçları ve tedarikçi araçları için farklı yetkilendirmeler yapılmasını sağlar.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Plaka tanıma sistemi, giriş-çıkış saatlerini kaydeder ve raporlar. Araç bazlı geçiş istatistikleri alınabilir. Kara liste özelliği ile istenmeyen araçların girişi engellenebilir. Sistem, IP kamera sistemleri ile entegre çalışarak, her geçişte araç fotoğrafı çeker ve kayıt altına alır. İstanbul, Kocaeli, Gebze, Tuzla ve Bursa bölgelerinde plaka tanıma entegreli bariyer sistemleri kurulumu yapıyoruz.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Geçiş Kontrol Entegrasyonu</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Bariyer sistemleri, geçiş kontrol sistemleri ile entegre çalışarak, hem araç hem de sürücü kontrolü sağlar. Sürücü, bariyer yanındaki kart okuyucu veya biyometrik cihaza kimliğini tanıtır. Sistem, hem sürücünün hem de aracın yetkili olup olmadığını kontrol eder. Bu çift faktörlü doğrulama, yüksek güvenlik gerektiren tesislerde kullanılır.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Ziyaretçi araçları için geçici kartlar veya QR kod sistemi kullanılabilir. Ziyaretçi, resepsiyondan aldığı QR kodu bariyer okuyucusuna gösterir ve giriş yapar. Çıkışta da aynı QR kod kullanılır ve ziyaret süresi kaydedilir. Tüm araç giriş-çıkışları raporlanabilir ve güvenlik analizi yapılabilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Güvenlik Özellikleri</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Modern bariyer sistemleri, çok sayıda güvenlik özelliği ile donatılmıştır. Fotosel sensörler, bariyer kolu altında araç veya insan varken kapanmayı engeller. Çarpma önleme sistemi, kola hafif bir temas durumunda kolun geri dönmesini sağlar. Bu özellik, araç hasarını ve bariyer arızasını önler.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Kol üzerinde LED ışık sistemi, karanlıkta görünürlüğü artırır ve güvenliği sağlar. Yansıtıcı şeritler ile kol daha belirgin hale gelir. Manuel açma mekanizması, acil durumlarda veya elektrik kesintisinde bariyerin manuel olarak açılmasını sağlar. Yangın alarm sistemi ile entegrasyon yapılarak, yangın durumunda otomatik açılma sağlanabilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Otopark Uygulamaları</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Bariyer sistemleri, otopark yönetiminde yaygın olarak kullanılır. Ücretli otoparklarda, giriş ve çıkış bariyerleri ile araç sayısı kontrol edilir ve ücret tahsilatı yapılır. Abone kartı sistemi ile düzenli kullanıcılar otomatik geçiş yapabilir. Bilet sistemi ile tek seferlik kullanıcılar ücret ödeyerek çıkış yapar.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Kapalı otoparklarda, kat bazlı bariyer sistemleri ile her katın doluluk durumu kontrol edilebilir. Dolu katlara giriş engellenebilir. Rezervasyon sistemi ile önceden yer ayırtılabilir. Fabrika ve sanayi tesislerinde, personel otoparkı, ziyaretçi otoparkı ve yönetici otoparkı için ayrı bariyer sistemleri kurulabilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bakım ve Servis Hizmetleri</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Bariyer sistemleri, düzenli bakım ile uzun ömürlü ve güvenilir çalışır. Yılda en az 2 kez periyodik bakım yapılmalıdır. Bakımda motor yağlaması, kol dengesi kontrolü, güvenlik sensörü testi, elektrik bağlantıları kontrolü ve yazılım güncellemesi yapılır. Kol üzerindeki LED ışıklar ve yansıtıcı şeritler kontrol edilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Arızalı motor değişimi, kol tamiri, sensör değişimi ve kontrol paneli onarımı hizmetleri sunuyoruz. 7/24 teknik destek hattımız ile her türlü sorun anında çözülür. İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Tuzla, Gebze, Kocaeli, Bursa ve diğer bölgelerde hızlı servis hizmeti veriyoruz. Acil durumlarda aynı gün müdahale garantisi sağlıyoruz. Tüm kurulumlarımız 2 yıl garanti kapsamındadır.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-white text-center mb-12">
              Sıkça Sorulan Sorular
            </h2>

            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden hover:border-slate-500/50 transition-all duration-300">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-xl font-bold text-white pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-2xl text-slate-400 group-open:rotate-180 transition-transform duration-300"></i>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-white text-center mb-12">
              Diğer Güvenlik Sistemleri Hizmetlerimiz
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link to="/guvenlik-sistemleri/turnike-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-gray-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-gray-700 to-gray-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-login-box-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-gray-400 transition-colors">Turnike Sistemleri</h3>
                <p className="text-gray-400 text-sm">Tripod ve kanatlı turnike sistemleri</p>
              </Link>

              <Link to="/guvenlik-sistemleri/gecis-kontrol-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-door-lock-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors">Geçiş Kontrol Sistemleri</h3>
                <p className="text-gray-400 text-sm">Kartlı ve biyometrik geçiş sistemleri</p>
              </Link>

              <Link to="/guvenlik-sistemleri/ip-kamera-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-camera-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">IP Kamera Sistemleri</h3>
                <p className="text-gray-400 text-sm">4K Ultra HD kamera kurulumu</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-700/20 to-slate-600/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Bariyer Sistemi Kurulumu İçin Hemen İletişime Geçin
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Ücretsiz keşif ve teknik danışmanlık için bizi arayın. Profesyonel ekibimiz size en uygun çözümü sunar.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-slate-700 to-slate-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-slate-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                +90 553 716 55 61
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </div>
  );
}